import camelCase from 'lodash.camelcase';
import startCase from 'lodash.startcase';

export const pascalCase = (str: string): string => {
    return startCase(camelCase(str)).replace(/ /g, '');
};

export const convertPascalCaseToKebabCase = (str: string): string => {
    return str.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();
};

export const removeInvalidCharactersForSearch = (str: string): string => {
    // keyboard symbols expect * and . to be removed since they might trigger complex query error if used without any alphanumeric character
    const specialChars = /[`~!@#$%^&*()_\-+=[{\]}\\|:;'",<.>/?]/g;
    if (str) {
        return str.replace(specialChars, '');
    }

    return '';
};

const brandPrefixesToRemove = ['MS '];

export const removeBrandPrefixFromLabel = (label: string): string => {
    for (const prefix of brandPrefixesToRemove) {
        if (label.startsWith(prefix)) {
            return label.replace(prefix, '').trim();
        }
    }

    return label;
};
